<div (scroll)="onTableScroll($event)" class="scroll-container">
    <table mat-table (scroll)="onTableScroll($event)" [dataSource]="tableData" matSort (matSortChange)="sortData($event)"
        matSortActive="{{displayedColumns[initSortColumn].columnDef}}" matSortDirection="{{initSortDirection}}">
    
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox *ngIf="selectable && selection.isMultipleSelection()" (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" style="width: 10px;">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selectable && selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>
    
        <!-- <ng-container matColumnDef="info" class="info">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let row">
                <app-user-group-info [groupGuid]="row.guid" [groupName]="row.name"></app-user-group-info>
            </td>
        </ng-container> -->
    
        <ng-container *ngFor="let column of displayedColumns" matColumnDef="{{column.columnDef}}">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class = "header8"> {{column.header}} </th>
            <td mat-cell *matCellDef="let row" [class.selected]="selectable && selection.isSelected(row)">
                <a *ngIf="column.columnDef === 'email'" [href]="'mailto:' + column.cell(row)"> {{column.cell(row)}} </a>
                <span *ngIf="column.columnDef !== 'email'">{{column.cell(row)}}</span> </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="row"
            [class.selected]="selectable && selection.isSelected(row)"></tr>
    
        <mat-paginator [length]="tableData.length" [pageSize]="take"></mat-paginator>
    
    </table>
</div>